import UserInfo from "@/features_signal/userInfo"
import Wallet from "@/features_signal/wallet"
import { useEffect } from "preact/hooks"
import { Auth } from "./features_signal/auth"
import { Favorite } from "./features_signal/favorite"
import { createLogger } from "./utils/logger"
import Pagcor from "./features_signal/pagcor"
import ApiSignals, { BusinessSignals } from "./apis/api_signals"
import { toast } from "react-toastify"
import { CustomError } from "./utils/error"
import { batch } from "@preact/signals"
import kycRequiredMethods from "./features_signal/kyc/kycRequiredMethods"
import { setGtmId } from "./features_signal/GA/ga"

const logger = createLogger("AppEffects")

let timeout: NodeJS.Timeout | null = null

export default function AppEffects() {
    logger.debug("AppEffects Render")
    //埋点接口
    useEffect(() => {
        setGtmId()
    }, [])

    useEffect(() => {
        document.getElementById("loading-view")?.remove()
        const unsubscribeAccessToken = Auth.accessTokenSignal.subscribe(async (accessToken) => {
            if (!Auth.accessTokenSignalSubscribeActive.value) {
                return
            }
            logger.debug("Token 已经更新:", accessToken)
            if (accessToken) {
                UserInfo.fetchUserInfo()
                Wallet.fetchWallet()
                Favorite.fetchFav()
            } else {
                UserInfo.clearUserInfo()
                Wallet.clearUserWallet()
                Favorite.clearFav()
            }
        })

        const unsubscribeProfile = BusinessSignals.kycSourceData.subscribe(
            async (kycSourceData) => {
                if (kycSourceData?.kyc?.status === "block" && BusinessSignals.isUserLogin.value) {
                    batch(() => {
                        if (timeout) {
                            clearTimeout(timeout)
                        }
                        timeout = setTimeout(async () => {
                            await kycRequiredMethods.openKycReminderHintBlockAccountLogin()
                            Auth.clearAccessToken()
                        }, 500)
                    })
                }
            },
        )

        const unsubscribeIsLogin = BusinessSignals.isUserLogin.subscribe(async (isLogin) => {
            if (!isLogin) {
                await Pagcor.openTermsAndConditions()
            }
            if (isLogin && !Pagcor.isTermsAndConditionsProceeded.value) {
                await Pagcor.openTermsAndConditions()
            }
        })

        return () => {
            unsubscribeAccessToken()
            unsubscribeIsLogin()
            unsubscribeProfile()
        }
    }, [])
    return null
}
